import { Component, Injector, OnInit } from '@angular/core';
import { UserRegisterationDto } from '@app/management/models/user-registeration-dto';
import { UsersService } from '@app/management/users-management/users-service.service';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { EncryptionService } from '@app/shared/services/Encryption.service';

@Component({
  selector: 'app-register-user',
  templateUrl: './register-user.component.html',
  styleUrls: ['./register-user.component.less'],
  providers: [UsersService],
})
export class RegisterUserComponent extends BaseComponent implements OnInit {
  passwordVisible = false;
  user: UserRegisterationDto = {
    encodedEmail: '',
    firstName: '',
    lastName: '',
    password: '',
    phoneNumber: '',
    resetToken: '',
    userName: '',
  };
  result = {
    show: false,
    title: '',
    subTitle: '',
  };
  email = '';
  token: any;
  constructor(
    injector: Injector,
    private encryptionService: EncryptionService,
    private userService: UsersService
  ) {
    super(injector);
  }

  ngOnInit() {
    const qParams = this.route.snapshot.queryParams;
    let encodedEmail = qParams['email'] as string;
    const token = qParams['recoveryToken'];
    if (encodedEmail == null || token == null) {
      this.notification.error(
        'Wrong link',
        'The Link is wrong,please check the url or check the system administrators'
      );
      return;
    } else {
      if (encodedEmail.includes(' ')) {
        encodedEmail = encodedEmail.replace(/ /g, '+');
      }
      this.email = this.encryptionService.decryptUsingTripleDES(encodedEmail);
      this.token = token;
    }
  }

  register() {
    this.user.password = this.encryptionService.encryptUsingTripleDES(
      this.user.password,
      false
    );
    this.user.encodedEmail = this.encryptionService.encryptUsingTripleDES(
      this.email,
      false
    );
    this.user.resetToken = this.token;
    this.userService.registerUser(this.user).subscribe(() => {
      this.result = {
        show: true,
        subTitle: 'Your account configured successfully',
        title: 'Registeration succeeded',
      };
    });
  }
}
